(function interceptHulkapps() {
  const new_money_format = "${{amount}} AUD";
  let internalValue;

  Object.defineProperty(window, 'hulkapps', {
    configurable: true,
    enumerable: true,
    set(obj) {
      obj.money_format = new_money_format;
      internalValue = obj;
      Object.defineProperty(window, 'hulkapps', {
        value: obj,
        writable: true,
        configurable: true,
        enumerable: true,
      });
    },
    get() {
      return internalValue;
    }
  });
})();